<template>
  <div>
    <OilDataCap
        :title="'Счет фактура'.toUpperCase()"
        :search-filter='onSearchValueChange'
        service-name="invoice"
        :buttons="[
                {
                  route: 'invoice',
                  name: 'Добавить Счет фактуру'
                }
             ]"
    />
    <v-divider class='my-2'/>
    <oil-table v-if='loading'
               :hide-footer="true"
               :item-counts="invoices.length+1"
               :keys="[
                          {
                            text:'Покупатель'.toUpperCase(),
                            value:'CompanyName'
                          },
                          {
                            text:'Договор'.toUpperCase(),
                            value:'ContractNumber'
                          },
                          {
                            text:'ИНН',
                            value:'TaxNo'
                          },
                          {
                            text:'Счет фактура'.toUpperCase(),
                            value:'Number'
                          },
                          {
                            text:'СКАЧАТЬ И ПЕЧАТЬ',
                            value:'PDFID'
                          },
                          {
                            text:'',
                            value:'Id'
                          },
                          {
                            text:'',
                            value:'DeleteId'
                          }
                       ]"
               :paginate='count'
               @paginateAction='paginate'
               :items='invoices'
    >

      <template v-slot:PDFID='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mr-6' type='button' icon
                   @click="showMePdf('invoice/print',value)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
              md='6'
              offset-md='3'
          >
            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deleteInvoice'
            />
          </v-col>
        </v-row>

      </template>

    </oil-table>
  </div>
</template>

<script>
import {invoiceService} from '@/services/InvoiceService'

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table.vue'),
    OilDataCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')
  },
  data: () => ({
    loading: false,
    invoices: [],
    count: {
      count: 0
    }
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  methods: {
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.invoices = data?.map(inv => {
        return {
          Id: inv?.Id,
          PDFID: inv?.Id,
          DeleteId: inv?.Id,
          TaxNo: inv?.Buyer?.TaxNo,
          CompanyName: inv?.Buyer?.CompanyName,
          ContractNumber: inv?.Contract?.Number,
          Number: `${inv?.Number}-${inv?.Waybill?.Number}`,
          InvoiceDate: inv?.InvoiceDate
        }
      })
    },
    handleRowClick(Id) {
      this.$router.replace({
        path: `invoice/${Id}`,
        replace: true
      })
    },
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    async deleteInvoice(id) {
      const response = await invoiceService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const invoice = this.invoices.find(({Id}) => Id === id)
        const index = this.invoices.indexOf(invoice)
        this.invoices.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `СЧЕТ ФАКТУРА под номером ${invoice.Number} удачно удален`
        })
      }
    },
    async paginate(page) {
      const invoices = await invoiceService.paginate(page)
      const {count, dates} = invoices.data
      this.count.count = count
      this.invoices = dates?.map(inv => {
        return {
          Id: inv?.Id,
          PDFID: inv?.Id,
          DeleteId: inv?.Id,
          TaxNo: inv?.Buyer?.TaxNo,
          CompanyName: inv?.Buyer?.CompanyName,
          ContractNumber: inv?.Contract?.Number,
          Number: `${inv?.Number}-${inv?.Waybill?.Number}`,
          InvoiceDate: inv?.InvoiceDate
        }
      }) || []
    },
  }

}
</script>